import React, { useEffect, useState } from "react";
import Carousel, { Modal, ModalGateway } from "react-images";
import { preloadAround } from "../../utils/preloadImages";
import LazyCarouselView from "../LazyCarouselView";
import "./index.scss";

const EXCLUDED = [35, 41, 48, 51];
const TOTAL = 141;

export const buildPuzzlePhotos = () => {
  const photos = [];
  for (let i = 1; i <= TOTAL; i++) {
    if (!EXCLUDED.includes(i)) {
      photos.push({
        source: `https://inmemoriambucket.s3.us-east-2.amazonaws.com/images/impreuna/${i}.jpg`,
      });
    }
  }
  return photos;
};

const PuzzleGallery = (props) => {
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);
  const [modalGatewayPhotos, setModalGatewayPhotos] = useState([]);

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
    props.onHide();
  };

  useEffect(() => {
    if (!props.show) {
      setViewerIsOpen(false);
      return;
    }

    const photos =
      modalGatewayPhotos.length > 0 ? modalGatewayPhotos : buildPuzzlePhotos();
    const urls = photos.map((p) => p.source);

    setModalGatewayPhotos(photos);
    setCurrentImage(0);
    setViewerIsOpen(true);
    preloadAround(urls, 0, 3);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.show]);

  const handleViewChange = (index) => {
    setCurrentImage(index);
    preloadAround(
      modalGatewayPhotos.map((p) => p.source),
      index,
      3
    );
  };

  return (
    <div>
      {props.show ? (
        <audio controls autoPlay className="d-none" loop>
          <source
            src="https://inmemoriambucket.s3.us-east-2.amazonaws.com/music/1+together/choristes.mp3"
            type="audio/mp3"
          />
          <source
            src="https://inmemoriambucket.s3.us-east-2.amazonaws.com/music/1+together/2+Handel.mp3"
            type="audio/mp3"
          />
          <source
            src="https://inmemoriambucket.s3.us-east-2.amazonaws.com/music/1+together/3+Maunier.mp3"
            type="audio/mp3"
          />
        </audio>
      ) : null}

      <ModalGateway>
        {viewerIsOpen && modalGatewayPhotos.length > 0 ? (
          <Modal onClose={closeLightbox}>
            <Carousel
              currentIndex={currentImage}
              views={modalGatewayPhotos}
              components={{ View: LazyCarouselView }}
              trackProps={{ onViewChange: handleViewChange }}
            />
          </Modal>
        ) : null}
      </ModalGateway>
    </div>
  );
};

export default PuzzleGallery;
